module.exports = __webpack_public_path__ + "6b2e7acd5c8697b61330b21928274fa1.pdf";